export const menuItems = [
    {
        id: 1,
        label: "Início",
        isTitle: true,
    },
    {
        id: 2,
        label: "Painel",
        icon: "bx-home-circle",
        link: "/",
        empresaRequired: false
    },
    {
        id: 6,
        isLayout: true
    },
    {
        id: 7,
        label: "Contribuinte",
        isTitle: true
    },
    /*
    {
        id: 8,
        label: "Dados da Empresa",
        icon: "bx-buildings",
        link: "/contribuinte/empresa",
        empresaRequired: true,
    },
     */
    {
        id: 9,
        label: "Solicitações",
        icon: "bx-task",
        link: "/contribuinte/solicitacao",
        empresaRequired: false
    },
    {
        id: 10,
        label: "Nota Fiscal",
        icon: "bx-detail",
        empresaRequired: true,
        subItems: [
            {
                id: 102,
                label: "Emitir NFS-e",
                link: "/contribuinte/nota-fiscal/gerar",
                parentId: 10
            },
            {
                id: 101,
                label: "Consultar NFS-e",
                link: "/contribuinte/nota-fiscal/lista",
                parentId: 10
            },
            {
                id: 103,
                label: "Cancelamentos",
                link: "/contribuinte/nota-fiscal/cancelamentos",
                parentId: 10
            },
        ]
    },
    {
        id: 20,
        label: "Ranfs",
        icon: "bx-receipt",
        empresaRequired: true,
        subItems: [
            {
                id: 202,
                label: "Emitir Ranfs",
                link: "/contribuinte/ranfs/gerar",
                parentId: 20
            },
            {
                id: 201,
                label: "Consultar Ranfs",
                link: "/contribuinte/ranfs/lista",
                parentId: 20
            },
        ]
    },
    {
        id: 30,
        label: "Financeiro",
        icon: "bx-dollar",
        empresaRequired: true,
        subItems: [
            {
                id: 302,
                label: "Fechamento Parcial",
                link: "/contribuinte/financeiro/fechamento-parcial",
                parentId: 30
            },
            {
                id: 302,
                label: "Declaração Mensal",
                link: "/contribuinte/financeiro/declaracao-mensal",
                parentId: 30
            },
            {
                id: 301,
                label: "DUAM",
                link: "/contribuinte/financeiro/guia",
                parentId: 30
            },
        ]
    },
    {
        id: 40,
        label: "Relatórios",
        icon: "bx-book-bookmark",
        empresaRequired: false,
        subItems: [
            {
                id: 401,
                label: "Notas Fiscais",
                link: "/contribuinte/relatorios/notas-fiscais",
                parentId: 40
            },
            {
                id: 402,
                label: "DUAMs",
                link: "/contribuinte/relatorios/duam",
                parentId: 40
            },
            /*{
                id: 403,
                label: "Livro Fiscal",
                link: "/contribuinte/relatorios/livro-fiscal",
                parentId: 40,
                empresaRequired: true,
            },*/
        ]
    },
    {
        id: 50,
        label: "Simples Nacional",
        icon: "bx-task",
        link: "/contribuinte/simples/fiscalizacao",
        empresaRequired: true
    },
];

